/* Sticky Add to Cart bar — drives the bottom-of-screen CTA on mobile + tablet.
   - Each sticky button programmatically clicks the corresponding bundle CTA
     so there's one source of truth (bundle-selector.js handles request,
     drawer rendering, discount application).
   - IntersectionObserver watches the page footer; when the user scrolls so
     the footer enters view, the bar auto-hides so footer controls (currency
     selector, links) are reachable.
   - Bar is moved to document.body on init so position:fixed works against
     the viewport (its rendered parent has a transform/sticky context).
*/
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('.sticky-add-to-cart-bar');
    if (!bar) return;

    // Scope source-button lookup to the main product so we don't grab buttons
    // from related/complementary products elsewhere on the page.
    var main = document.querySelector('product-info')
      || document.querySelector('[id^="MainProduct-"]')
      || document;

    // The sticky buttons proxy to whichever real buy buttons the page has:
    // the bundle selector (roller) OR the standard product form (hand wraps, etc.).
    var addBtn = bar.querySelector('.sticky-add-to-cart-bar__cta--add');
    var buyBtn = bar.querySelector('.sticky-add-to-cart-bar__cta--buy');
    var sourceAdd = main.querySelector('.bundle-selector__cta') || main.querySelector('.product-form__submit');
    var sourceBuy = main.querySelector('.bundle-selector__buy-now') || main.querySelector('.drago-buy-now');

    // Need at least a real Add to Cart to be useful.
    if (!addBtn || !sourceAdd) return;

    // Move out of the product's containing-block parent so position:fixed
    // anchors to the viewport.
    if (bar.parentNode !== document.body) {
      document.body.appendChild(bar);
    }

    function wireProxy(stickyBtn, sourceBtn) {
      stickyBtn.addEventListener('click', function () {
        stickyBtn.dataset.loading = 'true';
        try { sourceBtn.click(); } catch (err) {}
        setTimeout(function () { stickyBtn.dataset.loading = 'false'; }, 1500);
      });
    }
    wireProxy(addBtn, sourceAdd);

    // DRAGO ATC visibility — the sticky bar and the real Add-to-Cart button must
    // NEVER be on screen together. Show the sticky ONLY while the real button is
    // entirely below the viewport (user hasn't scrolled down to it yet). The instant
    // the real button's top edge enters from the bottom, hide the sticky; keep it
    // hidden all the way down, and when scrolled past (button above the viewport).
    // It reappears only when the user scrolls back up above the real button.
    // Driven by the scroll/resize handler below via getBoundingClientRect (more
    // reliable than IntersectionObserver thresholds for this exact edge).
    function checkMainAtc() {
      var rect = sourceAdd.getBoundingClientRect();
      if (rect.top >= window.innerHeight) {
        bar.classList.remove('is-main-atc-visible');
      } else {
        bar.classList.add('is-main-atc-visible');
      }
    }

    // Wire Buy Now if the page has one; otherwise drop it and let Add to Cart fill the row.
    if (buyBtn && sourceBuy) {
      wireProxy(buyBtn, sourceBuy);
    } else if (buyBtn) {
      buyBtn.parentNode.removeChild(buyBtn);
    }

    // Currency switcher: on change, submit a Shopify /localization POST built in
    // JS. Doing it here (rather than an inline <form>) keeps it working after the
    // bar is moved to <body> and avoids any nested-form HTML-parser issues.
    var currencySelect = bar.querySelector('[data-sticky-currency]');
    if (currencySelect) {
      currencySelect.addEventListener('change', function () {
        var code = currencySelect.value;
        if (!code) return;
        var f = document.createElement('form');
        f.method = 'POST';
        f.action = (window.routes && window.routes.root_url ? window.routes.root_url.replace(/\/$/, '') : '') + '/localization';
        f.style.display = 'none';
        var fields = [
          ['form_type', 'localization'],
          ['utf8', '✓'],
          ['_method', 'put'],
          ['country_code', code],
          ['return_to', window.location.pathname + window.location.search]
        ];
        for (var i = 0; i < fields.length; i++) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = fields[i][0];
          input.value = fields[i][1];
          f.appendChild(input);
        }
        document.body.appendChild(f);
        f.submit();
      });
    }

    document.body.classList.add('has-sticky-cart');
    requestAnimationFrame(function () { bar.classList.add('is-ready'); });

    // Hide when the PAGE footer is in view so the user can reach the footer's
    // currency selector and links. The cart drawer also contains a `.drawer__footer`
    // element, so be explicit: target a real <footer> tag that is NOT inside the
    // cart drawer.
    var pageFooter = null;
    var footers = document.querySelectorAll('footer');
    for (var i = 0; i < footers.length; i++) {
      if (!footers[i].closest('cart-drawer, .drawer, .cart-drawer')) {
        pageFooter = footers[i];
        break;
      }
    }
    // Two independent signals decide whether the bar is hidden near the bottom:
    //  (1) IntersectionObserver on the page footer, and
    //  (2) a scroll-position heuristic (near the bottom of the document).
    // Combine them through a single state so they never fight over the class.
    var footerVisible = false;
    var nearBottomByScroll = false;
    function updateHidden() {
      if (footerVisible || nearBottomByScroll) {
        bar.classList.add('is-near-footer');
      } else {
        bar.classList.remove('is-near-footer');
      }
    }

    if (pageFooter && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        footerVisible = entries.some(function (e) { return e.isIntersecting; });
        updateHidden();
      }, { rootMargin: '0px 0px 80px 0px', threshold: 0 });
      io.observe(pageFooter);
    }

    // Scroll fallback: hide the bar within ~520px of the page bottom so the
    // whole footer (currency selector included) is reachable, even if the
    // footer element isn't found or the observer doesn't fire.
    function checkNearBottom() {
      var scrollBottom = window.innerHeight + window.scrollY;
      var docHeight = document.documentElement.scrollHeight;
      nearBottomByScroll = scrollBottom >= docHeight - 520;
      updateHidden();
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { checkNearBottom(); checkMainAtc(); ticking = false; });
      }
    }, { passive: true });
    window.addEventListener('resize', function () { checkNearBottom(); checkMainAtc(); }, { passive: true });
    checkNearBottom();
    checkMainAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

